const pageBodyClasses = new Map([["/domy", "houses"]]);

const PAGE_BODY_CLASSES = [...pageBodyClasses.values()];

const PAGE_BODY_CLASSES_BY_PATH = Object.fromEntries(
  [...pageBodyClasses].flatMap(([pathname, bodyClass]) => [
    [pathname, bodyClass],
    [`${pathname}/`, bodyClass],
  ]),
);

const getPageBodyClass = (pathname) =>
  Object.hasOwn(PAGE_BODY_CLASSES_BY_PATH, pathname)
    ? PAGE_BODY_CLASSES_BY_PATH[pathname]
    : null;

module.exports = {
  PAGE_BODY_CLASSES,
  PAGE_BODY_CLASSES_BY_PATH,
  getPageBodyClass,
};
